
var BREAKPOINT_VALUE = 992;
var isMobileView;
var windowWidth = window.innerWidth;
document.addEventListener("DOMContentLoaded", function () {
  if (windowWidth < BREAKPOINT_VALUE) {
    isMobileView = true;
  } else {
    isMobileView = false;
  }

  (function ($) {
    var setDropdownState = function setDropdownState(container, dropdown, state, className) {
      if (state === "open") {
        $(container).find(dropdown).addClass(className);
      } else {
        $(container).find(dropdown).removeClass(className);
      }
    };

    if (!isMobileView) {
      $(".header").addClass("header-desktop");
    } else {
      $(".header").addClass("header-mobile");
    } //$(".header-desktop .gallery-menu .dropdown-item").eq(0).addClass("active");
    // $(".header-desktop .gallery-menu .dropdown-item .submenu-item")
    //   .eq(0)
    //   .addClass("active");
    // $(" .header .gallery-menu .dropdown-item").on("mouseover", function (e) {
    //   if (!isMobileView) {
    //     $(".header .gallery-menu .dropdown-item.active").removeClass("active");
    //     $(this).addClass("active");
    //   }
    // });
    // $(".header .gallery-menu .submenu-link").on("mouseenter", function (e) {
    //   if (!isMobileView) {
    //     $(
    //       ".header .gallery-menu .submenu-item:not(.submenu-item_start).active"
    //     ).removeClass("active");
    //     $(this).parent().addClass("active");
    //   }
    // });
    // $(".header .gallery-menu .dropdown-link").on("mouseover", function (e) {
    //   if (!isMobileView) {
    //     $(this).parent().find(".submenu-item.active").removeClass("active");
    //     $(this).parent().find(".submenu-item_start").eq(0).addClass("active");
    //   }
    // });
    // $(".header .menu-item ").on("mouseleave", function (e) {
    //   if (!isMobileView) {
    //     $(this).removeClass("active");
    //     $(this).parent().find(".submenu-item.active").removeClass("active");
    //     $(this).parent().find(".submenu-item_start").eq(0).addClass("active");
    //     $(".header .gallery-menu .dropdown-item.active").removeClass("active");
    //     $(".header .gallery-menu .dropdown-item").eq(0).addClass("active");
    //   }
    // });


    $(".burger").on("click", function () {
      $(".header").toggleClass("menu-open");
      $("body").toggleClass("fixed");
      $(".submenu-open").removeClass("submenu-open");
      setDropdownState(".cart-item", ".dropdown", "close", "open");
    });
    $(".preview-menu .dropdown-link, .header-mobile .list-menu .dropdown-link").on("click", function (e) {
      if (isMobileView) {
        e.preventDefault();
        $(this).parent().addClass("submenu-open");
      }
    });
    $(".header .btn-back").on("click", function () {
      if (isMobileView) {
        $(this).closest(".dropdown-item").removeClass("submenu-open");
      }
    }); // Currency dropdown

    $(".currency_dropdown-item").on("click", function (e) {
      if ($(this).find('.currency_name').text() !== $(".currency_current .currency_name").text() && $(this).find('.currency_code').text() !== $(".currency_current .currency_code").text()) {
        $("#aelia_cs_currencies option").removeAttr("selected");
        $("#aelia_cs_currencies").find('option[value="' + $(this).attr("data-value") + '"]').attr("selected", "selected");
        $(".currency_current .currency_name").text($(this).attr("data-label"));
        $(".currency_current .currency_code").text($(this).attr("data-value"));
        $(".currency_wrap").removeClass("open");
        $("#aelia_cs_currencies").closest("form").submit();
      }
    });
    $(".currency_current").on("click", function () {
      $(this).parent().toggleClass("open");
    });
    $(".currency_dropdown .close-btn").on("click", function () {
      $(".currency_wrap").removeClass("open");
    });
    $('body').on('click', function (e) {
      if (!$(e.target).closest('.currency_wrap').length && $('.currency_wrap').hasClass('open')) {
        $('.currency_wrap').removeClass('open');
      }

      if (!$(e.target).closest('.account-item').length && $('.header_link-account_menu').hasClass('open')) {
        $('.header_link-account_menu').removeClass('open');
      }
    });
    $(".js-login-link").on("click", function (e) {
      e.preventDefault();
      $(".header").removeClass("menu-open");
      $("body").removeClass("fixed");
      $(".submenu-open").removeClass("submenu-open");
      $(".modal-sign-in").addClass("open");
    });
    $(".modal_close-btn, .js-close-modal").on("click", function (e) {
      $(this).closest(".modal").find(".input-error").removeClass("input-error");
      $(this).closest(".modal").find("form").trigger('reset');
      $(this).closest(".modal").removeClass("open");
    });
    $(".modal_overlay").on("click", function () {
      $(this).closest(".modal").find(".input-error").removeClass("input-error");
      $(this).closest(".modal").find("form").trigger('reset');
      $(this).closest(".modal").removeClass("open");
    });
    $(".modal-open-link").on("click", function () {
      $(".modal.open .input-error").removeClass("input-error");
      $(".modal.open").removeClass("open");
      $(".modal-" + $(this).attr("data-modal")).addClass("open");
    });
    $(".form-open-link").on("click", function (e) {
      $(".registration-block.open .input-error").removeClass("input-error");
      $(this).closest(".registration-block").removeClass("open");
      $(".block-" + $(this).attr("data-form")).addClass("open");
    });
    $("body").on("input", "input, textarea", function (e) {
      $(this).closest(".form-row").removeClass("input-error");
    });
    $(".js-dropdown-label").on("click", function (e) {
      if (!$(".header").hasClass("menu-open")) {
        e.preventDefault();
        setDropdownState(".cart-item", ".dropdown", "open", "open");
      }
    });
    $(".cart-item .dropdown").on("click", ".js-close-dropdown", function () {
      setDropdownState(".cart-item", ".dropdown", "close", "open");
    });
    $('body').on('click', function (e) {
      if (!$(e.target).closest('.cart-item').length && $('.cart-item .dropdown').hasClass('open')) {
        setDropdownState(".cart-item", ".dropdown", "close", "open");
      }
    });
    $('#unauthPageTitle').remove();
    $('.js-account_menu').click(function (e) {
      if (!isMobileView) {
        e.preventDefault();
        $(this).next('.header_link-account_menu').toggleClass('open');
      }
    });
  })(jQuery);
});